import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import CoverPickerButton from '../components/CoverPickerButton';
import {
	CoverItem,
	Platform,
	DeviceType,
	Orientation,
	WriteDirection,
	PopOver,
	ArmrestsByCover,
} from 'sofa-reborn-react';
import { setCurrentLightbox } from '../store/application/actions';
import { hidePopOver } from '../store/popOver/actions';
import { selectSceneItem } from '../store/scene/actions';
import { localeService } from '../services';

function filterCovers(
	covers: CoverItem[],
	selectedCover: CoverItem,
	coverLimit: number,
	deviceType: DeviceType
): CoverItem[] {
	/* Remove selected cover */
	const withoutSelected = covers.filter((cover) => {
		return cover.articleId !== selectedCover.articleId;
	});
	if (deviceType === 'mobile' || deviceType === 'tablet') {
		return withoutSelected.length > coverLimit
			? withoutSelected.slice(0, coverLimit - 1)
			: withoutSelected;
	}

	let coversItems: CoverItem[] = [];
	const selected = covers.find((cover) => {
		return cover.articleId === selectedCover.articleId;
	});
	if (selected) {
		coversItems.push(selected);
		coversItems = coversItems.concat(withoutSelected);
	}
	return coversItems.length > coverLimit ? coversItems.slice(0, coverLimit) : coversItems;
}

const onButtonClick = (dispatch: AppDispatch, noValidConnection: PopOver): void => {
	if (noValidConnection.showPopOver) {
		dispatch(hidePopOver({ type: 'no-valid-connection' }));
	}
	dispatch(setCurrentLightbox('cover-picker'));
	dispatch(selectSceneItem(null));
	dispatch(
		hidePopOver({
			type: 'disabled-drag',
		})
	);
};

const CoverPickerButtonContainer: React.FC = () => {
	const selectedCover = useSelector<RootState, CoverItem>(
		(state) => state.cover.selectedCover as CoverItem
	);
	const covers = useSelector<RootState, CoverItem[]>((state) => state.cover.coverItems);
	const coverOnlyItems = useSelector<RootState, CoverItem[]>((state) => state.cover.coverOnlyItems);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const noValidConnection = useSelector<RootState, PopOver>(
		(state) => state.popOver.noValidConnection
	);
	const armrests = useSelector<RootState, ArmrestsByCover | null>(
		(state) => state.armrest.armrests
	);
	const hasArmrestPicker = armrests ? true : false;
	const coverOnly = useSelector<RootState, boolean | undefined>((state) => state.cover.coverOnly);

	const excludeSelectedCover = 1;
	const coverLimit =
		orientation === 'portrait' ? 9 : deviceType === 'mobile' && orientation === 'landscape' ? 8 : 6;
	const languageCode = localeService.getLanguageCode();

	const dispatch = useDispatch<AppDispatch>();
	const [isHovering, setIsHovering] = useState(false);

	const onPointerOver = () => {
		setIsHovering(true);
	};

	const onPointerLeave = () => {
		setIsHovering(false);
	};

	return (
		<CoverPickerButton
			covers={filterCovers(
				coverOnly ? coverOnlyItems : covers,
				selectedCover,
				coverLimit,
				deviceType
			)}
			addPlusSign={
				coverOnly
					? coverOnlyItems.length - excludeSelectedCover > coverLimit
					: covers.length - excludeSelectedCover > coverLimit
			}
			totalNrOfCovers={coverOnly ? coverOnlyItems.length : covers.length}
			selectedCover={selectedCover}
			platform={platform}
			deviceType={deviceType}
			orientation={orientation}
			writeDirection={writeDirection}
			hasArmrestPicker={hasArmrestPicker}
			isHovering={isHovering}
			languageCode={languageCode}
			onButtonClick={(): void => onButtonClick(dispatch, noValidConnection)}
			onPointerOver={(): void => onPointerOver()}
			onPointerLeave={(): void => onPointerLeave()}
		></CoverPickerButton>
	);
};

export default CoverPickerButtonContainer;
